import React, { useEffect } from 'react';
import Navigation from './components/Navigation';
import Sidebar from './components/Sidebar';
import Hero from './components/Hero';
import About from './components/About';
import TechnicalSkills from './components/TechnicalSkills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Education from './components/Education';

function App() {
  useEffect(() => {
    const els = document.querySelectorAll('section > .content');
    const obs = new IntersectionObserver(
      entries => entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          obs.unobserve(entry.target);
        }
      }),
      { threshold: 0.06 }
    );
    els.forEach(el => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    document.documentElement.dataset.topic = 'neutral';
  }, []);

  return (
    <>
      <Navigation />
      <Sidebar />
      <main className="main">
        <Hero />
        <About />
        <Experience />
        <TechnicalSkills />
        <Projects />
        <Education />
      </main>
    </>
  );
}

export default App;
